module.exports = __webpack_public_path__ + "img/bg_subway.83e59b6f.jpg";